import { Action, createReducer, on } from '@ngrx/store';
import {
  fetchNwmlsDetail,
  fetchNwmlsDetailFailure,
  fetchNwmlsDetailSuccess,
  fetchNwmlsList,
  fetchNwmlsListFailure,
  fetchNwmlsListSuccess,
} from './nwmls.action';

export interface NwmlsState {
  list: any[];
  detail:any;
  loading: boolean;
  error: any;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalRecords: number;
}

export const initialState: NwmlsState = {
  list: [],
  detail: null,
  loading: false,
  error: null,
  pageNumber: 1,
  pageSize: 10,
  totalPages: 100,
  totalRecords: 100,
};

export const NwmlsReducer = createReducer(
  initialState,
  on(fetchNwmlsList, (state) => {
    return { ...state, loading: true, error: null };
  }),
  on(fetchNwmlsListSuccess, (state, { response }) => {
    return {
      ...state,
      loading: false,
      list: response.result,
      pageNumber: response.pageNumber,
      pageSize: response.pageSize,
      totalPages: response.totalPages,
      totalRecords: response.totalRecords,
    };
  }),
  on(fetchNwmlsListFailure, (state, { error }) => {
    return { ...state, error, loading: false };
  }),

  on(fetchNwmlsDetail, (state) => {
    return { ...state, loading: true, error: null };
  }),
  on(fetchNwmlsDetailSuccess, (state, { response }) => {
    return {
      ...state,
      loading: false,
      detail: response
    };
  }),
  on(fetchNwmlsDetailFailure, (state, { error }) => {
    return { ...state, error, loading: false };
  })
);

// Selector
export function reducer(state: NwmlsState | undefined, action: Action) {
  return NwmlsReducer(state, action);
}
